/**
 * Address Service
 *
 * Handles address CRUD by organization/facility.
 * Single entry for address-related API calls.
 */

import { apiClient } from './apiClient';

/**
 * Add address.
 */
export const addAddress = async (address) => {
  const response = await apiClient.post('/api/web-api/AddressDetails/', address);
  return response.data;
};

/**
 * Update address.
 */
export const updateAddress = async (address_id, address) => {
  const response = await apiClient.put(`/api/web-api/AddressDetails/${address_id}/`, address);
  return response.data;
};

/**
 * Delete address.
 */
export const deleteAddress = async (address_id) => {
  await apiClient.delete(`/api/web-api/addresses/${address_id}/`);
};

/**
 * Get all addresses by organization ID.
 */
export const getAllAddresses = async (organizationId) => {
  const response = await apiClient.get(
    `/api/web-api/AddressDetails/?organization_id=${organizationId}`,
  );
  return response.data;
};

/**
 * Get all addresses by facility ID.
 */
export const getAllAddressesByFacId = async (facilityId) => {
  const response = await apiClient.get(`/api/web-api/AddressDetails/?facility_id=${facilityId}`);
  return response.data;
};
